import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item';

const ExcessDetails = ({
  claimInInitialPeriod = null,
  excessInitialAmount = false,
  claimInitialPeriodDays = false,
  excessNormalAmount = false
}) => {
  if (null === claimInInitialPeriod) {
    return <strong>No excess details on record</strong>
  }

  return (
    <div>
      <Item
        key="claim-in-initial-period"
        heading="Can claim in initial period?"
        content={claimInInitialPeriod ? 'Yes' : 'No'}
      />
      <Item
        key="excess-initial-amount"
        heading="Initial Excess Amount"
        content={`£${(excessInitialAmount / 100).toFixed(2)}`}
      />
      <Item
        key="claim-initial-period-days"
        heading="Initial Period (Days)"
        content={claimInitialPeriodDays}
      />
      <Item
        key="excess-normal-amount"
        heading="Normal Excess Amount"
        content={`£${(excessNormalAmount / 100).toFixed(2)}`}
      />
    </div>
  );
};

ExcessDetails.propTypes = {
  claimInInitialPeriod: PropTypes.bool,
  excessInitialAmount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]),
  claimInitialPeriodDays: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]),
  excessNormalAmount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]),
};

export default ExcessDetails;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/ExcessDetails.js